import React from "react";
function Footer() {
  return (
    <footer className="coh-container">
      <div
        className="coh-container ssa-component coh-component ssa-component-instance-c20fe9a0-6267-4067-b7d2-b58c68453935 coh-component-instance-c20fe9a0-6267-4067-b7d2-b58c68453935 coh-style-footer"
        id="footer"
        data-select-theme="light-grey"
      >
        <div className="coh-container tagline-bar">
          <div className="coh-container coh-container-boxed">
            <div className="coh-block">
              <div className="settings-tray-editable">
                <div>
                  <img
                    loading="lazy"
                    src="https://www.dewalt.com/sites/g/files/xnuzat961/files/2021-12/DEWALT-Guaranteed-Tough.png"
                    width="327"
                    height="23"
                    alt="DEWALT GUARANTEED TOUGH"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="coh-container footer-main">
          <div className="coh-container coh-container-boxed">
            <div className="coh-container menu-form-container">
              <div className="coh-row coh-row-xl coh-row-visible-xl">
                <div className="coh-row-inner coh-ce-a0192b1b-5cbe1723">
                  <div className="coh-column coh-hidden-sm coh-visible-xl coh-col-xl-6">
                    <div
                      className="coh-container main-menu"
                      data-menu-items-per-row="2"
                    >
                      <ul className="menu">
                        <li className="menu-item menu-item--expanded">
                          <span title="Products">Pellentesque consectetur</span>
                          <ul className="menu">
                            <li className="menu-item">
                              <a href="#top">Morbi pretium</a>
                            </li>
                            <li className="menu-item">
                              <a href="#top">Proin ante</a>
                            </li>
                            <li className="menu-item">
                              <a href="#top">Proin semper</a>
                            </li>
                            <li className="menu-item">
                              <a href="#top">Sed pretium</a>
                            </li>
                          </ul>
                        </li>
                        <li className="menu-item menu-item--expanded">
                          <span title="Systems">Proin semper</span>
                          <ul className="menu">
                            <li className="menu-item">
                              <a href="#top">Morbi pretium</a>
                            </li>
                            <li className="menu-item">
                              <a href="#top">Proin ante</a>
                            </li>
                            <li className="menu-item">
                              <a href="#top">Proin semper</a>
                            </li>
                            <li className="menu-item">
                              <a href="#top">Sed pretium</a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="coh-column form-column coh-visible-sm coh-col-sm-12 coh-visible-md coh-col-md-6 coh-col-md-push-0 coh-col-md-pull-0 coh-col-md-offset-0 coh-visible-xl coh-col-xl-5">
                    <div className="coh-block">
                      <div
                        id="block-righthandsideblockform"
                        className="settings-tray-editable"
                        data-drupal-settingstray="editable"
                      >
                        <div>
                          <p>EMAIL SIGNUP</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="coh-column coh-visible-sm coh-col-sm-12 coh-hidden-xl">
                    <div
                      className="coh-container main-menu"
                      data-menu-items-per-row="2"
                    >
                      <ul className="menu">
                        <li className="menu-item menu-item--expanded">
                          <span title="Products">Products</span>
                          <ul className="menu">
                            <li className="menu-item">
                              <a
                                href="#top"
                                title="Power Tools"
                                data-drupal-link-system-path="taxonomy/term/576846"
                              >
                                Power Tools
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                title="Hand Tools"
                                data-drupal-link-system-path="taxonomy/term/575686"
                              >
                                Hand Tools
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                data-drupal-link-system-path="taxonomy/term/575706"
                              >
                                Accessories
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                title="Outdoor"
                                data-drupal-link-system-path="taxonomy/term/577041"
                              >
                                Outdoor
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                data-drupal-link-system-path="taxonomy/term/577101"
                              >
                                Workspace
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                data-drupal-link-system-path="taxonomy/term/576756"
                              >
                                Storage
                              </a>
                            </li>
                            <li className="menu-item">
                              <a href="#top" target="_blank" rel="noopener">
                                Anchors
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li className="menu-item menu-item--expanded">
                          <span title="Systems">Systems</span>
                          <ul className="menu">
                            <li className="menu-item">
                              <a
                                href="#top"
                                data-drupal-link-system-path="node/876"
                              >
                                Cordless Platforms
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                title="Perform &amp; Protect"
                                data-drupal-link-system-path="node/766"
                              >
                                Perform &amp; Protect
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                title="Tool Connect"
                                data-drupal-link-system-path="node/901"
                              >
                                Tool Connect
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                title="See DEWALT Tough System"
                                data-drupal-link-system-path="node/796"
                              >
                                ToughSystem® Storage
                              </a>
                            </li>
                            <li className="menu-item">
                              <a href="#top" target="_blank" rel="noopener">
                                Jobsite WiFi System
                              </a>
                            </li>
                            <li className="menu-item">
                              <a href="#top" target="_blank" rel="noopener">
                                MOBILELOCK™
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li className="menu-item menu-item--expanded menu-item--active-trail">
                          <span title="Support">Support</span>
                          <ul className="menu">
                            <li className="menu-item menu-item--expanded menu-item--active-trail">
                              <a
                                href="#top"
                                data-drupal-link-system-path="node/736"
                                className="is-active"
                              >
                                Support Information
                              </a>
                              <ul className="menu">
                                <li className="menu-item">
                                  <a
                                    href="#top"
                                    target="_blank"
                                    data-drupal-link-system-path="node/59681"
                                  >
                                    Contact Us
                                  </a>
                                </li>
                              </ul>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                title="Find a Retailer"
                                data-drupal-link-system-path="find-retailer"
                              >
                                Find a Retailer
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                data-drupal-link-system-path="service-center"
                              >
                                Service Centers
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                title="Product Registration"
                                data-drupal-link-query='{"destination":"\/node\/631"}'
                                data-drupal-link-system-path="account-login"
                              >
                                Product Registration
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                data-drupal-link-system-path="node/2306"
                              >
                                Warranty Information
                              </a>
                            </li>
                          </ul>
                        </li>
                        <li className="menu-item menu-item--expanded">
                          <span title="DEWALT">About</span>
                          <ul className="menu">
                            <li className="menu-item">
                              <a
                                href="#top"
                                title="About Us"
                                data-drupal-link-system-path="node/811"
                              >
                                Why DEWALT
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                data-drupal-link-system-path="node/871"
                              >
                                Events
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                data-drupal-link-system-path="node/2601"
                              >
                                Awards
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                data-drupal-link-system-path="node/891"
                              >
                                Featured Articles
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                data-drupal-link-system-path="node/2641"
                              >
                                News &amp; Press
                              </a>
                            </li>
                            <li className="menu-item">
                              <a
                                href="#top"
                                data-drupal-link-system-path="node/2316"
                              >
                                The Tough Get Tougher
                              </a>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="coh-container copyright-social-container">
              <div
                className="coh-row coh-row-xl coh-row-visible-xl"
                data-coh-row-match-heights='{"xl":{"target":"none"}}'
              >
                <div className="coh-row-inner">
                  <div className="coh-column copyright-text-column coh-visible-ps coh-col-ps-12 coh-visible-sm coh-col-sm-12 coh-col-xl">
                    <div className="coh-container copyright-container">
                      <div className="coh-block">
                        <div
                          id="block-copyrightblock"
                          className="settings-tray-editable"
                          data-drupal-settingstray="editable"
                        >
                          <div>
                            <p className="copyright-title">
                              COPYRIGHT © DEWALT&nbsp;2023
                            </p>
                            <p className="coh-style-fine-print">
                              <span className="coh-style-paragraph---small">
                                The following are trademarks for one or more
                                DEWALT power tools, accessories, anchors and
                                concrete adhesives: The yellow and black color
                                scheme; the “D”-shaped air intake grill; the
                                array of pyramids on the handgrip; the kit box
                                configuration; and the array of lozenge-shaped
                                humps on the surface of the tool.&nbsp;
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="coh-column social-icon-column coh-visible-ps coh-col-ps-12 coh-visible-sm coh-col-sm-12 coh-visible-md coh-col-md-4 coh-col-xl">
                    <div className="coh-container social-container">
                      <div className="coh-block">
                        <div
                          id="block-socialiconsblock"
                          className="settings-tray-editable"
                          data-drupal-settingstray="editable"
                        >
                          <a
                            href="#top"
                            className="social-link-facebook"
                            target="_blank"
                            role="button"
                            aria-pressed="false"
                            aria-label="Facebook"
                            title="Facebook Icon"
                          >
                            <span>Facebook</span>
                          </a>
                          <a
                            href="#top"
                            className="social-link-instagram"
                            target="_blank"
                            role="button"
                            aria-pressed="false"
                            aria-label="Instagram"
                            title="Instagram Icon"
                          >
                            <span>Instagram</span>
                          </a>
                          <a
                            href="#top"
                            className="social-link-twitter"
                            target="_blank"
                            role="button"
                            aria-pressed="false"
                            aria-label="Twitter"
                            title="Twitter Icon"
                          >
                            <span>Twitter</span>
                          </a>
                          <a
                            href="#top"
                            className="social-link-youtube"
                            target="_blank"
                            role="button"
                            aria-pressed="false"
                            aria-label="YouTube"
                            title="YouTube Icon"
                          >
                            <span>YouTube</span>
                          </a>
                          <a
                            href="#top"
                            className="social-link-linkedin"
                            target="_blank"
                            role="button"
                            aria-pressed="false"
                            aria-label="LinkedIn"
                            title="LinkedIn Icon"
                          >
                            <span>LinkedIn</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="coh-container footer-legal">
          <div className="coh-container coh-container-boxed">
            <ul className="menu">
              <li className="menu-item">
                <a href="#top" target="_blank" rel="noopener">
                  Updated Privacy Policy
                </a>
              </li>
              <li className="menu-item">
                <a href="#top" data-drupal-link-system-path="node/856">
                  Terms Of Use
                </a>
              </li>
              <li className="menu-item">
                <a href="#top" data-drupal-link-system-path="node/2651">
                  Safety Notices and Recalls
                </a>
              </li>
              <li className="menu-item">
                <a href="#top" target="_blank" rel="noopener">
                  Power Tools Institute
                </a>
              </li>
              <li className="menu-item">
                <a href="#top" target="_blank" rel="noopener">
                  Travel Safety with Cordless Tools
                </a>
              </li>
              <li className="menu-item">
                <a href="#top" data-drupal-link-system-path="node/2646">
                  DEWALT Patent Information
                </a>
              </li>
              <li className="menu-item">
                <a href="#top" data-drupal-link-system-path="node/2611">
                  Shop Safe
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
